import { defineLevel } from '../schema';

/* ═══════════════════════════════════════════════════════════════════════════
   MONDE 1 · NIVEAU 1 — LA NUÉE.

     0:00  intro          6 s   aucun ennemi, la scène s'installe
     0:06  bloc A        12 s   montée — signature : balayage latéral
     0:18  bloc A2       14 s   la leçon du tir visé (l'Éclat)
     0:32  respiration    4 s   le niveau se termine sur une accalmie

   Premier des trois niveaux du monde 1. Il n'a PAS de boss : il se termine à
   l'horloge, sur la respiration, et la couche application enchaîne sur le
   niveau suivant du même monde sans écran de cartes — la progression du monde
   est continue, seul son FRANCHISSEMENT (le boss du dernier niveau) donne une
   carte.

   ⚠️ Times re-basés à partir de zéro : ce niveau reprend les blocs 0 → 3 de
   l'ancien `monde-1` sans en décaler l'espacement relatif — aucun bloc n'en
   coupe un autre, l'invariant que `levelSystem` exige toujours.
   ═══════════════════════════════════════════════════════════════════════════ */

export default defineLevel({
  id: 'monde-1-1',
  duration: 36,
  blocks: [
    { at: 0, wave: 'intro' },
    { at: 6, wave: 'a1-nuee' },
    { at: 18, wave: 'a2-lecon' },
    { at: 32, wave: 'respiration' },
  ],
});
